import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AboutTenantDetails from './AboutTenant/AboutTenantDetails';
import PanelWithTitleAndIcon from '../../common/PanelWithTitleAndIcon';

import { Tenant } from '../MatchModel';
import { MinimalRecordDetails } from '../../CreditCheck/Models';

import tr from '../../localization/translate';

import aboutTenantIcon from '../../assets/images/about-tenant.svg';
import s from './AboutTenant.scss';

function title(asSharedProfile) {
  if (asSharedProfile) {
    return tr('simple_pages.share_profile.about_tenant.title');
  }

  return tr('matching.about_tenant.title');
}

function AboutTenant({ asOfferProfile, asSharedProfile, checkCreditsLink, creditDetails, tenant }) {
  return (
    <PanelWithTitleAndIcon icon={aboutTenantIcon} title={title(asSharedProfile)}>
      <p
        className={classNames(
          'text tall_lines preserve_lines',
          s.description,
          { [s.no_description]: !tenant.description }
        )}
      >
        { tenant.description || tr('matching.no_entry') }
      </p>

      <AboutTenantDetails
        asOfferProfile={asOfferProfile}
        asSharedProfile={asSharedProfile}
        checkCreditsLink={checkCreditsLink}
        creditDetails={creditDetails}
        tenant={tenant}
      />
    </PanelWithTitleAndIcon>
  );
}

AboutTenant.propTypes = {
  asOfferProfile: PropTypes.bool,
  asSharedProfile: PropTypes.bool,
  checkCreditsLink: PropTypes.string,
  creditDetails: MinimalRecordDetails.propType.isRequired,
  tenant: Tenant.propType.isRequired
};

AboutTenant.defaultProps = {
  asOfferProfile: false,
  asSharedProfile: false,
  checkCreditsLink: ''
};

export default AboutTenant;
